import { render, staticRenderFns } from "./DocumentEdit.vue?vue&type=template&id=3841d55c&scoped=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=js"
export * from "./DocumentEdit.vue?vue&type=script&lang=js"
import style0 from "./DocumentEdit.vue?vue&type=style&index=0&id=3841d55c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3841d55c",
  null
  
)

export default component.exports